import React from "react";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import Spinner from "./components/Home/Spinner";
import Whatsapp from "./components/Home/Whatsapp";
import Navbar from "./components/NavBar/NavBar";
import Footer from "./components/Home/Footer";


const NotFound = () => {
    useEffect(() => {
  document.title =
    "404 - Page introuvable | UNIK SYSTEM Maroc";

  const meta = document.querySelector("meta[name='description']");
  if (meta) {
    meta.setAttribute(
      "content",
      "Erreur 404 : la page demandée est introuvable. Découvrez les solutions d’éclairage, plafonds tendus et aménagement intérieur proposées par UNIK SYSTEM au Maroc."
    );
  }

  // ✅ empêcher indexation Google
  let robots = document.querySelector("meta[name='robots']");
  if (!robots) {
    robots = document.createElement("meta");
    robots.setAttribute("name", "robots");
    document.head.appendChild(robots);
  }

  robots.setAttribute("content", "noindex, follow");

}, []);


  return (
    <>
      <Spinner />
      <Whatsapp />
      <Navbar />   
      

      <section className="notfound-section d-flex align-items-center text-center">
        <div className="container">

          {/* BIG 404 */}
          <h1 className="notfound-title">404</h1>

          {/* Message */}
          <h2 className="fw-bold mb-3">
            Page introuvable
          </h2>

          <p className="text-muted mb-4">
            La page que vous recherchez n'existe pas, a été déplacée
            ou est temporairement indisponible.
          </p>

          {/* Buttons */}
          <div className="d-flex justify-content-center gap-3 flex-wrap">

            <Link to="/" className="btn-primarya">
              <i className="fa-solid fa-house me-2"></i>
              Retour à l'accueil
            </Link>

            <Link to="/Contact" className="btn-outline">
              <i className="fa-solid fa-envelope me-2"></i>
              Nous contacter
            </Link>

          </div>

        </div>
      </section>

      <Footer />
    </>
  );
};

export default NotFound;